import styled from 'styled-components';

const ContainerWrapper = styled.div`
  width: 100%;
  background: linear-gradient(90deg, #0f319d 0%, #4ebbc6 100%);
`;

const FooterWrapper = styled.div<{ isTablet: boolean; isMobile: boolean }>`
  padding: ${(p) => (p.isTablet ? '40px 15px' : '40px 0')};
  width: 100%;
  max-width: 1290px;
  margin: auto;
  gap: 40px;
  display: flex;
  flex-direction: ${(p) => (p.isTablet ? 'column-reverse' : 'row')};
  justify-content: ${(p) => (p.isTablet ? 'center' : 'space-between')};
`;

const LeftWrapper = styled.div<{ isTablet: boolean; isMobile: boolean }>`
  width: 100%;
  max-width: ${(p) => (p.isTablet ? '100%' : '255px')};
  flex-shirnk: 0;
  color: ${(p) => p.theme.colors.light};
  font-family: 'Roboto', sans-serif;
  font-size: ${(p) => p.theme.fontSizes.base};
  display: flex;
  flex-direction: column;
  gap: 20px;

  .title {
    font-size: ${(p) => p.theme.fontSizes.base};
    font-weight: 700;
    margin-bottom: 5px;
  }

  .flex {
    display:flex;
    flex-direction: column;
    gap: 15px;
  }

  .infoBox {
    display: flex;
    gap: 15px;

    a {
      color: ${(p) => p.theme.colors.light};
    }
  }
`;

const RightWrapper = styled.div<{ isTablet: boolean; isMobile: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: ${(p) => (p.isTablet ? 'column' : 'row')};
`;

const Logo = styled.img`
  width: 356px;
  height: 100px;
  object-fit: contain;
  margin-bottom: 40px;
`;

const Navbar = styled.div<{ isTablet: boolean; isMobile: boolean, justify?: string }>`
  display: flex;
  width: 100%;
  gap: 30px;
  flex-direction: ${(p) => (p.isTablet ? 'column' : 'row')};
  justify-content: ${(p) => (p.isTablet ? 'center' : 'flex-end')};
  align-items: ${(p) => (p.isTablet ? 'center' : 'flex-start')};
  color: ${(p) => p.theme.colors.light};
  text-align: ${(p) => (p.isTablet ? 'center' : 'left')};
  
  @media (max-width: 1500px) {
    gap: 15px;
  }

  @media (max-width: 1351px) {
    gap: 30px;
  }

  .title {
    font-size: ${(p) => p.theme.fontSizes.sm};
    font-weight: 700;
    margin-bottom: 20px;
    white-space: nowrap;
  }
`;

const Anchor = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: ${(p) => p.theme.fontSizes.sm};
  color: ${(p) => p.theme.colors.light};
  text-decoration: none;
  cursor: pointer;
  margin-top: 20px;

`;

const MediaList = styled.div<{ isTablet: boolean; isMobile: boolean }>`
  flex: 1;
  display: flex;
  justify-content: ${(p) => (p.isTablet ? 'center' : 'flex-start')};
  gap: 20px;
`;

const MediaLink = styled.a`
  display: flex;
  width: 40px;
  height: 40px;
  object-fit: contain;
  cursor: pointer;
`;

const CopyRight = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: ${(p) => p.theme.fontSizes.base};
  font-weight: 400;
  line-height: 18.75px;
  color: ${(p) => p.theme.colors.light};
  margin-top: auto;
`;

const SearchIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  background: ${(p) => p.theme.colors.secondary500};
  color: ${(p) => p.theme.colors.light};
  border-radius: 0 5px 5px 0;
  display: flex;

  > img {
    margin: auto;
  }
`;

const SearchBar = styled.form`
  display: flex;
  width: 100%;
`;

const CollapsWrapper = styled.div`
    color: ${(p) => p.theme.colors.light};
  > .MuiList-root > div {
    padding: 5px 16px;
  }
`;

export {
  ContainerWrapper,
  FooterWrapper,
  LeftWrapper,
  RightWrapper,
  Logo,
  Navbar,
  Anchor,
  MediaList,
  MediaLink,
  CopyRight,
  SearchIconWrapper,
  SearchBar,
  CollapsWrapper,
};
